import React, { useState, useEffect } from "react";
import { FormStyles, TextStyles } from "styles/style";
import { useAuth } from "hooks/auth";
import { api } from "supabase/database/api.ts";

export default () => {
  const { user } = useAuth();
  const [userData, setUserData] = useState({
    name: '',
    date_of_birth: '',
    phone: '',
    address: '',
    email: ''
  });
  const [pendingUpdate, setPendingUpdate] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const pullData = async () => {
      if (!user?.email) return;
      const userdata = await api.authQueries.getUserInfo({ email: user.email });
      let pending = [];
      try {
        pending = await api.authQueries.GetPendingBasicInfoUpdate({ email: user.email }, true);
        console.log('userdata:', userdata);
        console.log('pending:', pending);
      } catch (error) {
        console.error('Error fetching pending updates:', error);
        pending = [];
      }
      
      // Parse date from YYYYMMDD to YYYY-MM-DD
      const rawDate = userdata[0].date_of_birth || '';
      const formattedDate = rawDate.length === 8
        ? `${rawDate.slice(0,4)}-${rawDate.slice(4,6)}-${rawDate.slice(6,8)}`
        : rawDate;
      
      setUserData({
        registration_number: userdata[0]?.registration_number || '',
        name: userdata[0]?.name || '',
        date_of_birth: formattedDate || '',
        phone: userdata[0]?.phone || '',
        address: userdata[0]?.address || '',
        email: userdata[0]?.email || ''
      });

      setPendingUpdate(pending.length > 0 ? pending[0] : null);
      if (pending.length > 0) {
        // Parse pending date from YYYYMMDD to YYYY-MM-DD
        const pendingRawDate = pending[0].date_of_birth || '';
        const pendingFormattedDate = pendingRawDate.length === 8
          ? `${pendingRawDate.slice(0,4)}-${pendingRawDate.slice(4,6)}-${pendingRawDate.slice(6,8)}`
          : pendingRawDate;
        
        setUserData({
            registration_number: pending[0]?.registration_number || '',
            name: pending[0]?.name || '',
            date_of_birth: pendingFormattedDate || '',
            phone: pending[0]?.phone || '',
            address: pending[0]?.address || '',
            email: pending[0]?.email || ''
        });
      }
    };
    pullData();
  }, [user?.email]);

  const handleFieldChange = (field, value) => {
    setUserData(prev => ({ ...prev, [field]: value }));
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    try {
      await api.authMutations.CreateBasicInfoUpdate({ 
        email: user.email, 
        formData: userData 
      });
      alert("Basic information submitted for verification!");
      // Refresh to show pending status
      window.location.reload();
    } catch (error) {
      alert("Failed to submit basic information");
      console.error("Error submitting basic information:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <FormStyles.FormContainer>
      {pendingUpdate && (
        <FormStyles.FormPendingNotification>
          <FormStyles.FormPendingContent>
            <FormStyles.FormPendingIcon></FormStyles.FormPendingIcon>
            <FormStyles.FormPendingText>
              <FormStyles.FormPendingTitle>Information Update Pending Verification</FormStyles.FormPendingTitle>
              <FormStyles.FormPendingDescription>Your information update is being reviewed and will be applied once verified.</FormStyles.FormPendingDescription>
            </FormStyles.FormPendingText>
          </FormStyles.FormPendingContent>
        </FormStyles.FormPendingNotification>
      )}
      <FormStyles.Form onSubmit={onSubmit}>
        <FormStyles.FormRow>
          <FormStyles.FormLabel>Registration Number</FormStyles.FormLabel>
          <TextStyles.SearchInput
            type="text"
            value={userData.registration_number || ''}
            placeholder="Your Registration Number"
            disabled
          />
        </FormStyles.FormRow>
        <FormStyles.FormRow>
          <FormStyles.FormLabel>Full Name</FormStyles.FormLabel>
          <TextStyles.SearchInput
            type="text"
            value={userData.name}
            onChange={(e) => handleFieldChange("name", e.target.value)}
            placeholder="Enter your full name"
          />
        </FormStyles.FormRow>

        <FormStyles.FormRow>
          <FormStyles.FormLabel>Date of Birth</FormStyles.FormLabel>
          <TextStyles.SearchInput
            type="date"
            value={userData.date_of_birth}
            onChange={(e) => handleFieldChange("date_of_birth", e.target.value)}
          />
        </FormStyles.FormRow>

        <FormStyles.FormRow>
          <FormStyles.FormLabel>Contact</FormStyles.FormLabel>
          <TextStyles.SearchInput
            type="tel"
            value={userData.phone}
            onChange={(e) => handleFieldChange("phone", e.target.value)}
            placeholder="+1234567890 (include country code)"
            pattern="^\+[1-9]\d{1,14}$"
            title="Please include country code (e.g., +1234567890)"
          />
        </FormStyles.FormRow>

        <FormStyles.FormRow>
          <FormStyles.FormLabel>Address</FormStyles.FormLabel>
          <TextStyles.SearchInput
            as="textarea"
            tw="h-32 resize-none"
            value={userData.address}
            onChange={(e) => handleFieldChange("address", e.target.value)}
            placeholder="Enter your address"
          />
        </FormStyles.FormRow>

        <FormStyles.FormRow>
          <FormStyles.FormLabel>Email</FormStyles.FormLabel>
          <TextStyles.SearchInput
            type="email"
            value={userData.email}
            onChange={(e) => handleFieldChange("email", e.target.value)}
            placeholder="Enter your email"
          />
        </FormStyles.FormRow>

        <FormStyles.FormSubmitButton type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Submitting..." : "Submit"}
        </FormStyles.FormSubmitButton>
      </FormStyles.Form>
    </FormStyles.FormContainer>
  );
};